var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"md-layout md-alignment-center"},[_c('md-progress-spinner',{attrs:{"md-diameter":_vm.diameter,"md-stroke":_vm.stroke,"md-mode":"indeterminate"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }